import { render, staticRenderFns } from "./DeletionRequestList.vue?vue&type=template&id=313cecf3&"
import script from "./DeletionRequestList.vue?vue&type=script&lang=js&"
export * from "./DeletionRequestList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports